import Bunzip from 'seek-bzip';
import BufferLib from 'buffer';
import Geography from './Geography';
import DataStream from 'datastream-js';


// REF
// https://www.html5rocks.com/en/tutorials/webgl/typed_arrays/
// https://github.com/kig/DataStream.js/blob/master/DataStream.js
// http://bl.ocks.org/xEviL/4921fff1d70f5601d159


export default class WECDM {
	constructor() {
		this.stream = null;
		this.header = [];
		this.data = null;
	}
	
	async readFile(fileElementOrBlob) {
		// XXX mmmmmm awesome
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			const self = this;
			reader.onload = function() {
				console.log("Loaded file");
				self.readBuffer(this.result);
				resolve();
			}
			reader.readAsArrayBuffer(fileElementOrBlob);
		});
	}
	
	/*
		data: ArrayBuffer
	*/
	readBuffer(data) {
		console.log(data);
		// Convert ArrayBuffer > Buffer > Buffer (Decoded bzip) > DataStream
		console.log(Buffer, DataStream);
		var wecdmData = Bunzip.decode(BufferLib.Buffer.from(data));
		this.stream = new DataStream(wecdmData, 0, DataStream.BIG_ENDIAN);
		var magic = this.stream.readString(5);
		var headerLen = this.stream.readInt32();
		var headerJSON = this.stream.readString(headerLen, 'UTF-8');
		this.header = JSON.parse(headerJSON);

		console.log("header: ");
		console.log(this.header);
	}
}
